import React, { createContext, useState } from 'react';
import axios from 'axios';
import { errorAlert, sweetalert } from '../helpers/SweetAlert';
// API 
import { getReport, fileUpload, fileUploadDispertion, fileUploadConfig } from '../api/Reports'

const FilesContext = createContext({});

export const FilesProvider = ({ children }) => {

  // states 
  // stado para manejar el loader 
  const [loading, setLoading] = useState(false);

  /**
   * 
   * @param {string} type 
   * @returns boolean
   * 
   * funcion para descargar reportes 
   */
  const requestReports = async (type, dates) => {
    try {
        setLoading(true);
        await getReport(type, dates)
        setLoading(false);
        return true
    } catch (e) {
        errorAlert(
        '',
        e.message ||
            '¡Disculpe ha ocurrido un error inesperado, por favor intente mas tarde!.',
        );
        setLoading(false);
        return false
    }
  }

  /**
   * 
   * @param {formdata} file // archivo
   * @param {string} type // tipo de archivo para dispersion o normal
   * @param {number} fileType nmero que representa el tipo de archivo
   * @returns boolean
   */
  const requestFileUpload = async (file, type, fileType) => {
    let res;
    try {
      setLoading(true);
      if(fileType.value === "yummers" || fileType.value === "commerces"){
        res = await fileUpload(file, type)
      }
      if( fileType.value === "dispertion"){
        res = await fileUploadDispertion(file)
      }  
      if( fileType.value === "config"){
        res = await fileUploadConfig(file)
      }
        setLoading(false);
        if((res?.data.message !== "Success" && fileType === 2) || (!res?.data.success && fileType === 1)) {
          errorAlert('', '¡Disculpe ha ocurrido un error inesperado, por favor intente mas tarde!.',);
          return false
        }
        sweetalert('Listo!', 'El archivo fue subido con exito.')
        return true
    } catch (e) {
        errorAlert(
        '',
        res.message ||
            '¡Disculpe ha ocurrido un error inesperado, por favor intente mas tarde!.',
        );
        setLoading(false);
    }
  }


  return (
    <FilesContext.Provider
      value={{
        loading,
        setLoading,
        requestReports,
        requestFileUpload
      }}
    >
      {children}
    </FilesContext.Provider>
  );
};
export default FilesContext;
